module.exports = "pegasus_template/assets/themelp1/creative/104.png";